import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { CustomToggleButton } from "components/CustomComponents/CustomToggleButton";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { themes } from "services/constants";
import { Pending } from "./Pending";
import { History } from "./History";
import { Apply } from "./Apply";

export const Incentive = () => {
  const { userScreenAccess } = useSelector((state) => state.tokenReducer);
  const [selectedComponent, setSelectedComponent] = useState("Pending");
  const [alignment, setAlignment] = useState("Pending");
  const dispatch = useDispatch();
  let access_check = checkEditorPermission(
    userScreenAccess?.module_details,
    "Apply",
    "Incentive"
  );
  const IncentiveGrpButton = [
    {
      value: "Pending",
      label: "Pending",
      onClick: () => {
        setSelectedComponent("Pending");
        dispatch(setGlobalSearchValue(""));
      },
    },
    {
      value: "History",
      label: "History",
      onClick: () => {
        setSelectedComponent("History");
        dispatch(setGlobalSearchValue(""));
      },
    },
    ...(access_check
      ? [
          {
            value: "Apply",
            label: "Apply",
            onClick: () => {
              setSelectedComponent("Apply");
              dispatch(setGlobalSearchValue(""));
            },
          },
        ]
      : []),
  ];

  const renderComponent = () => {
    switch (selectedComponent) {
      case "Pending":
        return <Pending />;
      case "History":
        return <History />;
      case "Apply":
        return (
          <Apply
            setSelectedComponent={setSelectedComponent}
            setAlignment={setAlignment}
          />
        );
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 2, paddingLeft: 2.5 }}></Mui.Grid>
      <Mui.Grid container sx={{ paddingTop: 2, paddingLeft: 2.5 }}>
        <Mui.Grid xs={4.4}>
          <CustomToggleButton
            alignment={alignment}
            handleChange={(_, newVal) => newVal && setAlignment(newVal)}
            buttons={IncentiveGrpButton}
            themes={themes}
          />
        </Mui.Grid>
      </Mui.Grid>
      <Mui.Grid>{renderComponent()}</Mui.Grid>
    </React.Fragment>
  );
};
